<template>
  <div></div>
</template>

<script>
export default {
  name: "SiteName",
  props: [],
  inject: ['updateSiteInfo'],
  data() {
    const root = process.env.VUE_APP_API;
    return {
      siteLogo: require("../../assets/logo_white_560.png"),
      logoText: "DATABASE",
      oemAPI: root + "/api/auth/oem",
      siteName: "REECH DATABASE",
      isOem: false,
    };
  },
  async mounted() {
    await this.fetchFromSiteInfo();
  },
  methods: {
    async fetchFromSiteInfo() {
      try {
        const response = await this.axios.post(this.oemAPI);
        if (response && response.data) {
          if (response.data.oem) {
            if(response.data.oem.site_logo && response.data.oem.site_logo.trim() !== '') {
              this.siteLogo = response.data.oem.site_logo;
            }
            if(response.data.oem.site_name && response.data.oem.site_name.trim() !== '') {
              this.siteName = response.data.oem.site_name;
            }

            this.$emit('updateSiteInfo', {
                siteLogo: this.siteLogo,
                logoText: "",
                siteName: this.siteName,
                isOem: true,
            });          
          } else {
            // 画像をreturn内で指定するとアクセス時にチラつくのでこちらに定義
            this.$emit('updateSiteInfo', {
                siteLogo: this.siteLogo,
                logoText: this.logoText,
                siteName: this.siteName,
                isOem: false,
            });     
          }
        }
      } catch (error) {
        console.error("タイトルの取得中にエラーが発生しました", error);
      }
    },
  },
};
</script>